import { usePermissions } from "hooks/usePermissions";
import { ACTIONS, openAction } from "utils/access";

export interface PlatformRole {
  /** View on the Integrations Platform page: every integration-platform page,
   * read-only, for the clients assigned to the user, no secret values. */
  canView: boolean;
  /** Contribute: secret values of connections and webhook triggers. */
  canReveal: boolean;
  /** Contribute: Run Now, Re-run, DLQ redrive. */
  canRun: boolean;
  /** Manage: settings, connections, secrets, schedules, webhooks, on/off. */
  canEdit: boolean;
  /** Manage: integration lifecycle (register/delete) and pipeline structure
   * (add/remove steps, stage/order). */
  canManageStructure: boolean;
}

/**
 * What the page shows of the integration platform, from the server's access-group
 * decisions (integration_platform/api/core/permissions.py). These are visibility
 * gates only - the API enforces its own permissions regardless, and Client View
 * changes nothing.
 */
export function usePlatformRole(): PlatformRole {
  const { sees, mayDo } = usePermissions();
  return {
    canView: sees(openAction("integrations_platform")),
    canReveal: sees(ACTIONS.INTEGRATIONS_PLATFORM_REVEAL),
    canRun: mayDo(ACTIONS.INTEGRATIONS_PLATFORM_RUN),
    canEdit: mayDo(ACTIONS.INTEGRATIONS_PLATFORM_EDIT),
    canManageStructure: mayDo(ACTIONS.INTEGRATIONS_PLATFORM_STRUCTURE),
  };
}
